import React, { useEffect, useState } from "react";

export default function CereriPuncte() {
  const [cereri, setCereri] = useState([]);
  const [membri, setMembri] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [actionId, setActionId] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const [resCereri, resMembri] = await Promise.all([
          fetch("https://prdp-api.suport-949.workers.dev/api/puncte-requests", {
            headers: { Authorization: "Bearer unwantedtok" },
          }),
          fetch("https://prdp-api.suport-949.workers.dev/api/membri", {
            headers: { Authorization: "Bearer unwantedtok" },
          }),
        ]);
        if (!resCereri.ok) throw new Error("Eroare la încărcarea cererilor");
        if (!resMembri.ok) throw new Error("Eroare la încărcarea membrilor");
        const cereriData = await resCereri.json();
        const membriData = await resMembri.json();

        // Filtrăm cererile acceptate
        const cereriActive = cereriData.filter((c) => c.status !== "acceptat");

        // Alăturăm numele membrilor cererilor
        const cereriCuNume = cereriActive.map((cerere) => {
          const membru = membriData.find((m) => m.id === cerere.id_membru);
          return {
            ...cerere,
            prenume: membru?.prenume || "",
            nume: membru?.nume || "",
          };
        });

        setCereri(cereriCuNume);
        setMembri(membriData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  async function handleDecide(id, status) {
    setActionId(id);
    try {
      await fetch(
        `https://prdp-api.suport-949.workers.dev/api/puncte-requests/${id}/decide`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json", Authorization: "Bearer unwantedtok" },
          body: JSON.stringify({
            status,
            operator_id: "admin-bn",
            motiv_decizie: status === "acceptat" ? "Aprobată" : "Respinsă",
          }),
        }
      );
      setCereri((prev) => prev.filter((c) => c.id !== id));
    } catch (err) {
      setError("Eroare la actualizarea cererii.");
    }
    setActionId(null);
  }

  if (loading) return <div>Se încarcă cererile...</div>;
  if (error) return <div className="text-danger">{error}</div>;
  if (!cereri.length) return <div>Nu există cereri în așteptare.</div>;

  return (
    <div>
      <h3 style={{ color: "#01358D", fontWeight: "700" }}>Cereri pentru atribuirea de puncte</h3>
      <table className="table table-striped align-middle" style={{ background: "#f4f7ff", borderRadius: 12 }}>
        <thead>
          <tr>
            <th>#</th>
            <th>Membru</th>
            <th>Puncte</th>
            <th>Motiv</th>
            <th>Detalii</th>
            <th>Status</th>
            <th>Acțiune</th>
          </tr>
        </thead>
        <tbody>
          {cereri.map((c, idx) => (
            <tr key={c.id}>
              <td>{idx + 1}</td>
              <td>
                {c.prenume} {c.nume}
              </td>
              <td style={{ fontWeight: "700", color: "#01358D" }}>{c.puncte}</td>
              <td>{c.motiv}</td>
              <td>{c.detalii || "-"}</td>
              <td>
                <span
                  style={{
                    backgroundColor: c.status === "pending" ? "#f6c500" : "#e55353",
                    padding: "2px 12px",
                    borderRadius: 14,
                    color: "#222",
                    fontWeight: "600",
                    display: "inline-block",
                    minWidth: 80,
                  }}
                >
                  {c.status === "pending" ? "În așteptare" : "Respinsă"}
                </span>
              </td>
              <td>
                {c.status === "pending" && (
                  <>
                    <button
                      disabled={!!actionId}
                      className="btn btn-success btn-sm"
                      onClick={() => handleDecide(c.id, "acceptat")}
                    >
                      Acceptă
                    </button>{" "}
                    <button
                      disabled={!!actionId}
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDecide(c.id, "refuzat")}
                    >
                      Respinge
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
